import dayjs from "./dayjs";
import { FixedDateRanges } from "./types";

export default function generateDateRanges(startDate:dayjs.Dayjs|string, endDate:dayjs.Dayjs|string, minDate:dayjs.Dayjs|string, maxDate:dayjs.Dayjs|string): FixedDateRanges {
  // try to open to the month selected
  // if a single month, open to that month as the start month
  // if multiple months, open to the last month as the end month and the month prior as the start month
  let displayMonth1, displayMonth2;
  if ( dayjs.utc(endDate).startOf("month").isSame(dayjs.utc(startDate).startOf("month")) ) {
    displayMonth1 = dayjs.utc(startDate).startOf("month").startOf("day");
    displayMonth2 = dayjs.utc(startDate).add(1, "months").startOf("month").startOf("day");
  } else {
    displayMonth1 = dayjs.utc(endDate).subtract(1, "months").startOf("month").startOf("day");
    displayMonth2 = dayjs.utc(endDate).startOf("month").startOf("day");
  }

  if ( displayMonth2.isAfter(dayjs.utc()) ) {
    displayMonth1 = displayMonth1.subtract(1, "months").startOf("day");
    displayMonth2 = displayMonth2.subtract(1, "months").startOf("day");
  }

  // do the same for displayYear1, displayYear2
  let displayYear1, displayYear2;
  if ( dayjs.utc(endDate).startOf("year").isSame(dayjs.utc(startDate).startOf("year")) ) {
    displayYear1 = dayjs.utc(startDate).startOf("year").startOf("day");
    displayYear2 = dayjs.utc(startDate).add(1, "years").startOf("year").startOf("day");
  } else {
    displayYear1 = dayjs.utc(endDate).subtract(1, "years").startOf("year").startOf("day");
    displayYear2 = dayjs.utc(endDate).startOf("year").startOf("day");
  }

  if ( displayYear2.startOf("year").isAfter(dayjs.utc()) ) {
    displayYear1 = displayYear1.subtract(1, "years").startOf("day");
    displayYear2 = displayYear2.subtract(1, "years").startOf("day");
  }

  return {
    dateStart: dayjs.utc(startDate).startOf("day"),
    dateEnd: dayjs.utc(endDate).startOf("day"),

    today: [dayjs.utc().startOf("day"), dayjs.utc().startOf("day")],
    yesterday: [dayjs.utc().subtract(1, "days").startOf("day"), dayjs.utc().subtract(1, "days").startOf("day")],
    last7Days: [dayjs.utc().subtract(6, "days").startOf("day"), dayjs.utc().startOf("day")],
    last10Days: [dayjs.utc().subtract(9, "days").startOf("day"), dayjs.utc().startOf("day")],
    last14Days: [dayjs.utc().subtract(13, "days").startOf("day"), dayjs.utc().startOf("day")],
    last30Days: [dayjs.utc().subtract(29, "days").startOf("day"), dayjs.utc().startOf("day")],

    thisWeek: [dayjs.utc().startOf("isoWeek").startOf("day"), dayjs.utc().endOf("isoWeek").startOf("day")],
    lastWeek: [dayjs.utc().subtract(1, "weeks").startOf("isoWeek").startOf("day"), dayjs.utc().subtract(1, "weeks").endOf("isoWeek").startOf("day")],
    thisMonthWeeks: [dayjs.utc().startOf("month").startOf("isoWeek").startOf("day"), dayjs.utc().endOf("month").endOf("isoWeek").endOf("day")],
    lastMonthWeeks: [dayjs.utc().subtract(1, "months").startOf("month").startOf("isoWeek").startOf("day"), dayjs.utc().subtract(1, "months").endOf("month").endOf("isoWeek").startOf("day")],
    last12Weeks: [dayjs.utc().subtract(12, "weeks").startOf("isoWeek").startOf("day"), dayjs.utc().endOf("isoWeek").startOf("day")],

    thisMonth: [dayjs.utc().startOf("month").startOf("day"), dayjs.utc().endOf("month").startOf("day")],
    lastMonth: [dayjs.utc().subtract(1, "months").startOf("month").startOf("day"), dayjs.utc().subtract(1, "months").endOf("month").startOf("day")],
    thisYear: [dayjs.utc().startOf("year").startOf("day"), dayjs.utc().endOf("month").startOf("day")],
    lastYear: [dayjs.utc().subtract(1, "years").startOf("year").startOf("day"), dayjs.utc().subtract(1, "years").endOf("year").startOf("day")],
    last6Months: [dayjs.utc().subtract(6, "months").startOf("month").startOf("day"), dayjs.utc().endOf("month").startOf("day")],
    last12Months: [dayjs.utc().subtract(12, "months").startOf("month").startOf("day"), dayjs.utc().endOf("month").startOf("day")],

    month1: displayMonth1,
    month2: displayMonth2,
    year1: displayYear1,
    year2: displayYear2,
    minDate: dayjs.utc(minDate),
    maxDate: maxDate ? dayjs.utc(maxDate) : dayjs.utc(),
  };
}